// Mobile orientation input; the renderer keeps its existing easing and mouse input.
export default function enableTilt(pointer, motion) {
  if (!window.isSecureContext || !window.DeviceOrientationEvent || !window.matchMedia('(pointer: coarse)').matches) {
    return
  }
  let baseline = null

  function reset() {
    baseline = null
    pointer.x = 0
    pointer.y = 0
  }

  function orient(event) {
    if (motion.matches || document.hidden || !Number.isFinite(event.beta) || !Number.isFinite(event.gamma)) {
      return
    }
    if (!baseline) {
      baseline = { beta: event.beta, gamma: event.gamma }
    }
    const delta = (value, start) => ((value - start + 540) % 360) - 180
    const x = delta(event.gamma, baseline.gamma)
    const y = delta(event.beta, baseline.beta)
    const angle = (screen.orientation?.angle ?? window.orientation ?? 0) * Math.PI / 180
    const clamp = (value) => Math.max(-1, Math.min(1, value / 25))

    pointer.x = clamp(x * Math.cos(angle) + y * Math.sin(angle)) * .4
    pointer.y = clamp(y * Math.cos(angle) - x * Math.sin(angle)) * .3
  }

  // Use sensor events when already available, without requesting permission.
  window.addEventListener('deviceorientation', orient, { passive: true })
  window.addEventListener('orientationchange', reset)
  screen.orientation?.addEventListener('change', reset)
  document.addEventListener('visibilitychange', reset)
  motion.addEventListener('change', reset)
}
